import React, { useEffect, useState } from "react";
import "./loadingAnimation.css";
import BallFallAnimation from "../../common/animations/BallFall/BallFall";
import BallPulseAnimation from "../../common/animations/BallPulse/BallPulse";
import BallRotateAnimation from "../../common/animations/BallRotate/BallRotate";

const LOADING_STAGES = [
  {
    message: "Collecting your data",
    animation: <BallFallAnimation />
  },
  {
    message: "Sorting the ones and zeros",
    animation: <BallRotateAnimation />
  },
  {
    message: "Dropping things into place",
    animation: <BallPulseAnimation />
  }
];

const waitAndMoveToNextStage = (
  currentStage,
  setStage,
  timeToWait,
  infinite
) => {
  let nextStage = currentStage + 1;
  if (currentStage >= LOADING_STAGES.length - 1) {
    if (!infinite) return null;
    nextStage = 0;
  }

  return setTimeout(() => {
    setStage(nextStage);
  }, timeToWait);
};

const LoadingAnimation = () => {
  const [stage, setStage] = useState(0);
  const { animation, message } = LOADING_STAGES[stage];

  useEffect(() => {
    const timer = waitAndMoveToNextStage(stage, setStage, 4000, true);

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  });

  return (
    <section className={"loading-animation__container"}>
      <div className={"loading-animation__container-dots"}>{animation}</div>
      <h3>{message}</h3>
      <h5>This won't take too long</h5>
    </section>
  );
};

export default LoadingAnimation;
